export default __webpack_public_path__ + "static/media/dsaf-assignment01.docx.b55cb6af.pdf";